import React, { useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import ContactForm from './ContactFormAlt'
import FadeIn from '../../../components/Animation/FadeIn'
import MovingBackground from '../../../partials/MovingBackground/MovingBackground'
import Background from '../../../assets/backgrounds/contact-form.svg'

const Reimagine = () => {
    const scrollRef = useRef<HTMLDivElement>(null)

    return (
        <div className='md:bg-sand relative overflow-hidden' id='lynxForm'>
            <MovingBackground
                component={Background}
                classes={{ background: 'mix-blend-multiply' }}
                animate
            >
                <div className='side-padding'>
                    <div className='py-12 md:py-30 relative 3xl:max-w-screen-2xl mx-auto'>
                        <FadeIn>
                            <div>
                                <div className='max-w-[460px] mx-auto text-center hidden md:block pb-10'>
                                    <FormattedMessage id='page.epp.contactForm.title' tagName='h2' />
                                </div>
                                <div className='flex flex-col items-center relative'>
                                    <ContactForm scrollRef={scrollRef} />
                                </div>
                            </div>
                        </FadeIn>
                    </div>
                </div>
            </MovingBackground>
        </div>
    )
}

export default Reimagine
